import { render, staticRenderFns } from "./BaseBranchCablePrices.vue?vue&type=template&id=53b1774b"
import script from "./BaseBranchCablePrices.vue?vue&type=script&lang=js"
export * from "./BaseBranchCablePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports